import Mock from "../mock";
import shortId from "shortid";

const NotificationDB = {
  list: [
    {
      id: shortId.generate(),
      heading: "Message",
      icon: { name: "chat", color: "primary" },
      timestamp: 1705959987448,
      title: "New message from Ali",
      subtitle: "Do you have world wars lecture flashcards?",
      path: "chat",
    },
    {
      id: shortId.generate(),
      heading: "Alert",
      icon: { name: "notifications", color: "error" },
      timestamp: 1705959832719,
      title: "Due date passed",
      subtitle: "You need to study history flashcards",
      path: "page-layouts/user-profile",
    },
    {
      id: shortId.generate(),
      heading: "Message",
      icon: { name: "chat", color: "primary" },
      timestamp: 1705954892719,
      title: "New message from Omar",
      subtitle:
        "Hi, plz send me databases monday lecture flashcards I didn't attend 🙏",
      path: "chat",
    },
    {
      id: shortId.generate(),
      heading: "Urgent Message",
      icon: { name: "warning", color: "warning" },
      timestamp: 1705954892719,
      title: "New message from Dr. Hasan",
      subtitle:
        "Hi Akbar, when are you going to release the knowledge check generation feature?",
      path: "chat",
    },
  ],
};

Mock.onGet("/api/notification").reply(() => {
  const response = NotificationDB.list;
  return [200, response];
});

Mock.onPost("/api/notification/add").reply(() => {
  const response = NotificationDB.list;
  return [200, response];
});

Mock.onPost("/api/notification/delete").reply((config) => {
  let { id } = JSON.parse(config.data);
  console.log(config.data);

  const response = NotificationDB.list.filter(
    (notification) => notification.id !== id
  );
  NotificationDB.list = [...response];
  return [200, response];
});

Mock.onPost("/api/notification/delete-all").reply(() => {
  NotificationDB.list = [];
  const response = NotificationDB.list;
  return [200, response];
});
